import { render } from "./vehicle-details-list.vue?vue&type=template&id=33534ce6"
import script from "./vehicle-details-list.vue?vue&type=script&lang=js"
export * from "./vehicle-details-list.vue?vue&type=script&lang=js"

import "./vehicle-details-list.vue?vue&type=style&index=0&id=33534ce6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__